import { Session } from '../../utils/Session';

import { Component, Vue } from 'vue-property-decorator';
import useWebFont from '../../../src_server/common/web-font';
(window as any).pages = [];
import jwt from 'jsonwebtoken';

/**
 * グローバルミックスイン
 */
@Component
export default class PagesMixin extends Vue {
  /**
   *
   */
  get isJwtEnable() {
    const token = Session.getJwtToken();
    try {
      const inToken: any = jwt.decode(token);
      // console.log('inToken', inToken, inToken.exp, (new Date().getTime() + 1) / 1000);
      if (inToken.exp < (new Date().getTime() + 1) / 1000) {
        return false;
      }
    } catch (err) {
      return false;
    }
    return true;
  }

  mounted() {
    // console.log('mixin mounted', this.isJwtEnable);
    if (!this.isJwtEnable) {
      // console.log('mixin mounted expired ');
      Session.logout();
    }
  }

  updated() {
    if (!(window as any).pages.includes(location.href)) {
      // console.log('use web font', location.href);
      useWebFont(this);
      (window as any).pages.push(location.href);
    }
  }
}
